var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { fade, makeStyles, Drawer, Grid } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: fade(theme.palette.primary.main, 0.35),
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    paper: {
        borderRadius: theme.spacing(10, 10, 0, 0),
        padding: theme.spacing(6),
        maxHeight: '70%',
        [theme.breakpoints.up('md')]: {
            position: 'static',
            width: 'max-content',
            maxWidth: 500,
            height: 'unset',
            borderRadius: theme.spacing(4),
        },
    },
    container: {
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
}));
const Modal = (_a) => {
    var { open, classes: newClasses = {}, children, onClose } = _a, props = __rest(_a, ["open", "classes", "children", "onClose"]);
    const baseClasses = useStyles();
    const classes = mergeClasses({ newClasses, baseClasses, Component: Modal });
    return (React.createElement(Drawer, Object.assign({ anchor: 'bottom', open: open, onClose: onClose, classes: { root: classes.root, paper: classes.paper } }, props),
        React.createElement(Grid, { container: true, direction: 'column', className: classes.container }, children)));
};
export default Modal;
